import { Router } from '@solidjs/router';
import { Component, ErrorBoundary } from 'solid-js';
import { ThemeProvider } from './app/contexts/Theme';
import I18nProvider from './app/contexts/I18nProvider';
import App from './app';
import './app/styles/reboot.css';
import ErrorOverlay from '@components/ErrorOverlay';
const Entry: Component = () => {
  return (
    <ThemeProvider>
      <I18nProvider>
        <ErrorBoundary fallback={(e) => <ErrorOverlay error={String(e)} />}>
          <Router>
            <App />
          </Router>
        </ErrorBoundary>
      </I18nProvider>
    </ThemeProvider>
  );
};

export default Entry;
